<script>
export default {
  methods: {
    disableAutoComplete() {
      let elements = document.querySelectorAll('[autocomplete="off"]');

      if (!elements) {
        return;
      }

      elements.forEach(element => {
        element.setAttribute("readonly", "readonly");
        element.style.backgroundColor = "inherit";

        setTimeout(() => {
          element.removeAttribute("readonly");
        }, 500);
      });
    }
  },
  mounted() {
    this.disableAutoComplete();
  }
};
</script>
